import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [sp] = useSearchParams();
    const next = sp.get("next") || "/";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const res = await login(email, password);
        setSubmitting(false);
        if (!res.ok) toast.error(res.error || "Login failed");
        else {
            toast.success("Welcome back");
            navigate(next, { replace: true });
        }
    };

    return (
        <div className="grid min-h-[80vh] place-items-center bg-obsidian px-6" data-testid="login-page">
            <div className="w-full max-w-md border border-border-dim bg-surface p-10">
                <p className="text-[11px] uppercase tracking-[0.4em] text-gold">Atelier access</p>
                <h1 className="mt-4 font-display text-4xl text-white">Sign in</h1>
                <form onSubmit={onSubmit} className="mt-8 space-y-5">
                    <div>
                        <label className="text-[11px] uppercase tracking-[0.25em] text-white/60">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="login-email"
                            className="mt-2 w-full border border-border-dim bg-transparent px-4 py-3 text-sm text-white outline-none focus:border-gold"
                        />
                    </div>
                    <div>
                        <label className="text-[11px] uppercase tracking-[0.25em] text-white/60">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="login-password"
                            className="mt-2 w-full border border-border-dim bg-transparent px-4 py-3 text-sm text-white outline-none focus:border-gold"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="login-submit"
                        className="w-full bg-gold py-4 text-[12px] uppercase tracking-[0.3em] text-obsidian transition-colors hover:bg-gold-light disabled:opacity-50"
                    >
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                </form>
                <p className="mt-6 text-center text-sm text-white/60">
                    New to the atelier?{" "}
                    <Link to={`/register?next=${encodeURIComponent(next)}`} className="text-gold hover:underline">
                        Create an account
                    </Link>
                </p>
            </div>
        </div>
    );
}
